module.exports = __webpack_public_path__ + "images/img-1adnqyW.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/en/1.png
// module id = 2321
// module chunks = 0